export default __webpack_public_path__ + "static/media/brand-logo-for-dark-background.150e752e.png";